import { Constructor } from './constructor.type';
import { DynamicProperty } from '../decorators/dynamic-property.decorator';
import { IDynamicContextBindingConfig } from '../types/dynamic-context-binding-config.interface';

export interface IDynamicValueMixin {
  valueContext: IDynamicContextBindingConfig;
  expressionValue: string | undefined;
}
export type DynamicValueCtor = Constructor<IDynamicValueMixin>;

export function mixinDynamicValue<T extends Constructor<{}>>(base: T): DynamicValueCtor & T {
  class DynamicValueMixin extends base implements IDynamicValueMixin {
    @DynamicProperty() valueContext!: IDynamicContextBindingConfig;
    @DynamicProperty() expressionValue: string | undefined;

    constructor(...args: any[]) {
      super(...args);
    }
  }

  return DynamicValueMixin;
}
